module.exports = __webpack_public_path__ + "img/footer_pic.d892c553.jpg";